export default __webpack_public_path__ + "static/media/visa-white.27717aca.svg";